<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <b-form @submit.prevent="SimpanMaklumat">
            <h3 class="mb-0">MAKLUMAT PEMBERIAN KENAIKAN GAJI TAHUNAN (KGT) TAMBAHAN KHAS 2023</h3>
            <br />
            <div class="pl-lg-2">

                <br />
                <validation-provider name="AmaunTelahTerima" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Amaun Dalam Buku Servis:</b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='6'>
                            <b-form-input v-model="Obj.AmaunTelahTerima" :state="getValidation(validationContext)" style="width: 80%"></b-form-input>               
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Tarikh Kuatkuasa</b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='6'>
                            <b-form-input v-model="Obj.EftDate" :state="getValidation(validationContext)" readonly style="width: 40%"></b-form-input>
                        </b-col>
                    </b-row>
                </validation-provider>
                <br />
                <validation-provider name="Catatan" :rules="{ required: true }" v-slot="validationContext">
                    <b-row class="my-1">
                        <b-col lg='3'>Catatan</b-col>
                        <b-col lg='1'>:</b-col>
                        <b-col lg='6'>
                             <b-form-textarea v-model="Obj.Catatan" class="custom-input" rows="4" maxlength="1000" placeholder="Masukkan catatan (maksimum 1000 aksara)"></b-form-textarea>
                        </b-col>
                    </b-row>
                </validation-provider>
                <b-col>&nbsp;</b-col>
                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit">SIMPAN</b-button>
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->
                                    <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
        </b-form>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    props: ["tahun", "elemenId"],
    data() {
        return {

            Obj: {
                EftDate: "01-01-2023",
                Catatan: `Pemberian KGT Tambahan Khas 2023 sebanyak RM100 mengikut PP1/2023`,
            },
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },

        SimpanMaklumat() {
            this.Obj.coid = Store.state.MaklumatPeribadi.coid;
            this.Obj.tahun = this.tahun;
            this.Obj.elemenId = this.elemenId;
            console.log("log", this.Obj);

            GetsalaryService.setElemenKGTKhas(this.Obj).then((resp) => {
                this.StatusSimpan = resp.data;
            }).then(() => {

                console.log("StatusSimpan", this.StatusSimpan);

                if (this.StatusSimpan.Status == 1) {
                    swal
                        .fire({
                            title: "BERJAYA DI SIMPAN!",
                            text: "KLIK OK UNTUK TERUSKAN.",
                            icon: "success",
                        })
                        .then(() => {
                            this.$emit("batal");
                        });
                } else {
                    swal.fire({
                        title: this.StatusSimpan.details,
                        text: "KLIK OK UNTUK TERUSKAN.",
                        icon: "error",
                    }).then(() => {
                        this.$emit("batal");
                    });
                }
            });
        }

    },
    created() {

    }
}
</script>
